import type { AnyAction, ThunkAction } from '@reduxjs/toolkit';

import { adaptPageURLToStore } from 'src/adapters/pageURLToStore/adaptPageURLToStore';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions } from '../slice';
import type { SyncProductsQueryFromURLPayload } from '../types/ProductsQueryState';

export const syncFromURL = (
  asPath: string,
): ThunkAction<SyncProductsQueryFromURLPayload, ReduxApplicationState, undefined, AnyAction> => {
  return (dispatch, getState) => {
    const state = getState();
    const payload: SyncProductsQueryFromURLPayload = {
      ...adaptPageURLToStore(asPath, state),
      asPath,
    };

    dispatch(actions.syncFromURLPayload(payload));

    return payload;
  };
};
